import axios from 'axios';

const state= {
    Items:[],
    Loadings:{
        list:false,
        equipment : false,
    },
    ListingEquiment : [],
    Filter: null
};

const getters = {
    Items : (state) => state.Items,
    Filter : (state) => state.Filter,
    Loadings : (state) => state.Loadings,
    ListingEquiment : (state) => state.ListingEquiment
};

const actions = {
    async getItems({commit}, params){
        let filter = params.filter;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.get(`api/maintenance/schedule`, {params:params})
                .then(response => {
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setFilter', filter );
                    commit( 'setItems', response.data.data );
                    // commit( 'setListingEquiment', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async getItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/contracts/${params.contract_id}/maintenance-schedule/${params.schedule_id}`)
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async saveSchedule({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/contracts/${params.contract_id}/maintenance-schedule`, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                },
                data : params
            })
            .then(response => {
                commit( 'addItems', response.data.data );
                commit( 'addListingEquiment', params.equipment_list );
                resolve( response );
              
            })
            .catch(error => reject( error ));
        });
    },
    async updateSchedule({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/contracts/${params.contract_id}/maintenance-schedule/${params.id}`, {
                method: "PUT",
                headers: {
                  Accept: "application/json",
                },
                data : params
            })
            .then(response => {
                commit( 'UpdateItems', response.data.data );
                commit( 'addListingEquiment', params.equipment_list );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteSchedule({commit},params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios(`/api/contracts/${params.contract_id}/maintenance-schedule`, {
                method: "DELETE",
                headers: {
                  Accept: "application/json",
                },
                data : {
                    ids : params.ids
                }
            })
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    listItemEquipmentFilter({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/maintenance/schedule/equipments`, {
                params: params
            })
            .then(response => {
                commit('setListingEquiment', response.data.data);
                resolve(response.data.data);
            })
            .catch(error => reject( error ));
        });
    },
    async cloneSchedule({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/contracts/${params.contract_id}/maintenance-schedule-clone`, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                },
                data : {
                    'items': params.ids,
                    'start_date': params.start_date,
                    'end_date': params.end_date,
                    'maintenance_id': params.maintenance_id
                }
            })
            .then(response => {
                commit( 'addItems', response.data.data );
                commit( 'addListingEquiment', params.equipment_list );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items = data.items;
    },
    setFilter (state, data) {
        state.Filter = data;
    },
    setLoadings (state,data) {
        if(data.key === "list"){
            state.Loadings.list = data.val;
        }
        if(data.key === "equipment"){
            state.Loadings.equipment = data.val;
        }
    },
    setListingEquiment (state,data) {
        state.ListingEquiment = data.equipments;
    },
    addListingEquiment (state,data) {
      let ListingEquiment = [];
       state.Items.forEach(element => {
         Array.prototype.push.apply(ListingEquiment,element.equipment_list); 
       });
       state.ListingEquiment = ListingEquiment;
    },
    addItems (state,data) {
        state.Items = [...state.Items,data];
    },
    UpdateItems (state,data) {
        state.Items = state.Items.map(item => item.id === data.id ? data : item)
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}